/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Helmet } from 'react-helmet-async'

import '../styles/main.scss'
import Hero from '../components/hero/hero'
import DecidingWinners from '../components/decidingWinners'
import JudgesPanel from '../components/judges/judges'
import Articles from '../components/articles'
import 'animate.css'
import Winners from '../components/winners/winners'
import PublicChoiceAndInternalData from '../components/publicChoiceAndInternalData'
import AnimationObserver from '../components/helpers/animation-observer/animation-observer'

const PostAwardsPage = () => (
  <div>
    <Helmet>
      <title>Uswitch Telecoms Awards 2024 | Uswitch</title>
      <meta
        name="description"
        content="The Uswitch Telecoms Awards highlight the best of the best in UK broadband and mobiles. Winners are decided by our judging panel of tech experts, and insights from customers and industry data."
      />
    </Helmet>
    <div sx={{ background: '#EFEFEF' }}>
      <Hero
        subtitle="Your shortcut to smarter switching."
        schedule="Check out this year's winners across broadband, mobiles and TV."
      />
      <div sx={{ pb: 72, margin: 'auto', maxWidth: '1038px' }}>
        <Winners />
      </div>

      <section sx={{ px: ['16px', 0], pb: [24, 42], background: 'primary' }}>
        <div sx={{ maxWidth: '1226px', mx: 'auto' }}>
          <AnimationObserver>
            <DecidingWinners />
            <JudgesPanel />
          </AnimationObserver>
        </div>
      </section>

      <div sx={{ pb: 64 }}>
        <Articles />
        <PublicChoiceAndInternalData />
      </div>
    </div>
  </div>
)

export default PostAwardsPage
